<script>

    import { toast } from 'bulma-toast'
    import { creditStore, creditsStore, notifyStore, modalStore } from '../stores'

    import CreditsService from '../$services/credits.service.js'
    import DateMethod from '../$methods/date.method.js'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'

    let loading = false

    async function deleteCredit() {

        loading = true
        const resp = await CreditsService.deleteCredit($creditStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        creditsStore.remove($creditStore._id)
        notifyStore.set('wallet_updated')

        toast({message: 'Credito borrado', type: 'is-success'})

        modalStore.close()
    }

</script>

<Spinner {loading} />

{#if !loading}
    <DetailsCard
        title="Crédito"
        meta={DateMethod.dateTimeLarge($creditStore.created)}
        statusValue={$creditStore.status}
    >
        <DetailsFields>
            {#if $creditStore.admin && $creditStore.admin.email}
                <DetailsField label="Admin">
                    <div>
                        <div>{ $creditStore.admin.name }</div>
                        <div><b>{ $creditStore.admin.email }</b></div>
                    </div>
                </DetailsField>
            {/if}
            {#if $creditStore.user.email}
                <DetailsField label="Usuario">
                    <div>
                        <div>{ $creditStore.user.name }</div>
                        <div><b>{ $creditStore.user.email }</b></div>
                    </div>
                </DetailsField>
            {/if}
            <DetailsField label="Procesador" value={$creditStore.processor} />
            <DetailsField label="Método" value={$creditStore.method} />
            <DetailsField label="Referencia" value={$creditStore.reference} mono />
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <ButtonModal modalId="credit_update_modal" icon="edit" text="Actualizar" />
                <ButtonDelete on:confirm={deleteCredit} {loading} />
            </div>
        </div>
    </DetailsCard>
{/if}
